import { createGenericStore } from '@/stores/utils/genericStore.js'

export const useChecklistsStore = createGenericStore('checklists', '/api/v1/checklists')
